import { atom } from 'jotai';

export const patientConsentModalOpenAtom = atom<boolean>(false);

/**
 * Per-open state for the consent journey event. The modal owns the terminal
 * log but only the content component sees the save result, and the content is
 * a `next/dynamic` child, so the two communicate through this atom rather than
 * props. Reset on each open.
 */
export interface PatientConsentAttempt {
  confirmed: boolean;
  /** Bounded token from the last failed save; null when none has failed. */
  lastErrorType: string | null;
}

export const PATIENT_CONSENT_ATTEMPT_INITIAL: PatientConsentAttempt = {
  confirmed: false,
  lastErrorType: null,
};

export const patientConsentAttemptAtom = atom<PatientConsentAttempt>(
  PATIENT_CONSENT_ATTEMPT_INITIAL
);
